export const enum ReplacementFileTypesEnum {
  DRAWING = "drawing_file",
  COVER_LETTER = "covering_letter_file"
}
